export default __webpack_public_path__ + "static/media/hellstrikes1.2e7ef923.png";